import type { AddressParts, ProjectVersionStatus } from './project-status-types';

import { PROJECT_STATUS_OPTIONS } from './project-status-constants';

export function formatAddress({ street, streetNumber, postalCode, locality }: AddressParts): string | null {
    const parts: string[] = [];

    const streetPart = [street, streetNumber].filter(Boolean).join(' ');
    if (streetPart) {
        parts.push(streetPart);
    }

    const locationPart = [postalCode, locality].filter(Boolean).join(' ');
    if (locationPart) {
        parts.push(locationPart);
    }

    return parts.length > 0 ? parts.join(', ') : null;
}

export function getStatusLabel(
    status: ProjectVersionStatus | null | undefined,
    fallback: string,
): string {
    if (!status) {
        return fallback;
    }
    return PROJECT_STATUS_OPTIONS.find(option => option.value === status)?.label as string ?? fallback;
}
